(function ($) {
  $(document).ready(function () {
    $(".animated-screen .animated-image").each(function () {
      // Clone the img src and set it as background-image for each .animated-image
      var imgSrc = $(this).find("img").attr("src");
      $(this).css("background-image", "url(" + imgSrc + ")");
    });
    animateSlider();

    function setBgPosition() {
      $('.animated-screen .col-two .animated-image').each(function () {
        var extraSpace = $(window).outerWidth() - 1410;
        var halfSpace = extraSpace / 2;
        var bgPositionX = halfSpace;
        $(this).css('background-position', bgPositionX + 'px 50%');
      });
    }

    setBgPosition();
    $(window).resize(function () {
      setBgPosition();
    });
  });

  function animateSlider() {
    var verticalSlider = $('.vertical-slider');
    if (verticalSlider.length) {
      $(window).scroll(function () {
        var stickyOff1 = verticalSlider.offset().top - 55;
        var stickyOff2 = $('.animated-screen:last-child').offset().top - 356;
        var scroll = $(window).scrollTop();
        if (scroll >= stickyOff1) {
          verticalSlider.removeClass('screen-scroll');
        } else {
          verticalSlider.addClass('screen-scroll');
        }
        if (scroll >= stickyOff2) {
          verticalSlider.addClass('screen-scroll');
        }
        $('.animated-screen').each(function () {
          var screen = $(this);
          var screenOffset = screen.offset().top;
          if (scroll >= screenOffset) {
            screen.addClass('screen-active');
            screen.prev().removeClass('screen-active');
          } else {
            screen.removeClass('screen-active');
          }
        });
      });
    }
  }
})(jQuery);
